export default "__VITE_ASSET__CJzP5jJN__"